import React, { useState } from 'react';
import {
  arrayOf, bool, number, shape, string,
} from 'prop-types';
import { Select } from 'antd';
import I18n from 'i18n-js';
import textIncludes from 'helpers/textIncludes';

const SelectChemicalProduct = ({
  disabled = false,
  inputName,
  options = [],
  selectedValue = null,
}) => {
  const [value, setValue] = useState(selectedValue);

  return (
    <>
      <Select
        allowClear
        disabled={disabled}
        filterOption={(input, option) => textIncludes(option.label, input)}
        aria-label={I18n.t('chemicals.select_chemical_product')}
        onChange={(val) => setValue(val ?? null)}
        options={options}
        placeholder={I18n.t('chemicals.select_chemical_product')}
        showSearch
        style={{ width: '100%' }}
        value={value}
      />
      <input name={inputName} type="hidden" value={value ?? ''} />
    </>
  );
};

SelectChemicalProduct.propTypes = {
  disabled: bool,
  inputName: string.isRequired,
  options: arrayOf(
    shape({
      label: string.isRequired,
      value: number.isRequired,
    }),
  ),
  selectedValue: number,
};

export default SelectChemicalProduct;
